module.exports = __webpack_public_path__ + "5aeff961.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/Tabla red.png
// module id = 1298
// module chunks = 0 1